<template lang="pug">
  .swiper(v-if="items.length")
    Swiper.carousel(ref="projectsCarousel" :options="{ breakpoints: { 1500: { slidesPerView: 2 } }, slidesPerView: 1, grabCursor: true }")
      SwiperSlide.slide(v-for="item in items" :key="item.id")
        ProjectTile.tile(:project="item" @archive="archive(item, $event)")
  .no-items(v-else)
    img(src="/img/sofa.png")
    | Нет проектов
    Btn.btn-create-project(round xl green :to="{ name: 'project-create' }") Создать проект
</template>

<script>
import api from '@/api/project';

import ProjectTile from '@/components/ProjectTile.vue';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'ProjectCarousel',
  components: { ProjectTile, Swiper, SwiperSlide },
  data() {
    return {
      items: [],
    };
  },
  created() {
    // todd move to state
    api.fetchList({ page: this.page, isArchived: false }, true)
      .then((r) => { this.items = r.items; });
  },
  methods: {
    prev() {
      const swiper = this.$refs?.projectsCarousel?.$swiper;
      swiper.slideTo(swiper.activeIndex - 1);
    },
    next() {
      const swiper = this.$refs?.projectsCarousel?.$swiper;
      swiper.slideTo(swiper.activeIndex + 1);
    },
    archive(project, isArchive) {
      api.archive(project.id, isArchive, true)
        .then(() => { this.items = this.items.filter((item) => item !== project); });
    },
  },
};
</script>

<style scoped lang="scss">
  .swiper {
    width: calc(100% + 40px);
    position: relative;
    left: -20px;
    height: 100%;
  }

  .carousel {
    height: 100%;
  }

  .slide {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
  }

  .tile {
    height: 100%;
    box-sizing: border-box;
  }

  .no-items {
    margin: 20px 0;
    padding: 30px;
    border: 1px solid #EBEFF2;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #99A3C5;

    img {
      margin-bottom: 15px;
    }

    .btn-create-project {
      margin-top: 64px;
    }
  }

  // CSS Grid/Flexbox bug size workaround
  // @see https://github.com/kenwheeler/slick/issues/982
  // no scoped
  .swiper {
    display: grid;

    .swiper-container{
      height: 100%;
      //max-height: 100vw;
      min-height: 0;
      min-width: 0;
      max-width: 100vw;
      width: 100%;
      overflow: hidden;
    }

    .swiper-slide{
      width: auto;
      flex-shrink: 0;
      display: block;
      height: 100%;
      max-height: 100%;
    }

    .swiper-wrapper{
      max-height: 100%;
      height: 100%;
      display: flex;
      min-height: 0;
      min-width: 0;
    }
  }
</style>
